if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      

const formData = JSON.parse(serializeForm(this.form));
const customFields = document.querySelectorAll('.cup-customisation [name^="properties["]');


const selectedStyle = document.querySelector('#cup-style')?.value;

const upgradeVariantsElement =
  document.querySelector('#cup-upgrade-variants');

const upgradeVariants = upgradeVariantsElement
  ? JSON.parse(upgradeVariantsElement.textContent)
  : {};

const upgradeId = upgradeVariants[selectedStyle];

const quantity = Number(formData.quantity || 1);

const cupItem = {
  id: Number(formData.id),
  quantity: quantity,
  properties: {}
};

Object.keys(formData).forEach((key) => {
  const match = key.match(/^properties\[(.*)\]$/);
  if (match) {
    cupItem.properties[match[1]] = formData[key];
  }
});

customFields.forEach((field) => {
  const match = field.name.match(/^properties\[(.*)\]$/);

  if (match && field.value.trim()) {
    cupItem.properties[match[1]] = field.value;
  }
});
const baubleName = document.getElementById('bauble-personalisation');
const baubleGlitter = document.getElementById('bauble-glitter');

if (baubleName && baubleGlitter) {
  cupItem.properties['Personalisation'] = baubleName.value;
  cupItem.properties['Glitter Colour'] = baubleGlitter.value;
}
const items = [cupItem];

if (upgradeId) {
  items.push({
    id: Number(upgradeId),
    quantity: quantity,
    properties: {
      'Cup Style': selectedStyle
    }
  });
}

const body = JSON.stringify({
  items: items,
  sections: this.cartNotification.getSectionsToRender(),
  sections_url: window.location.pathname
});


      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  });
}
